(function () {
  function initTabs(root) {
    var toggles = root.querySelectorAll('[data-toggle]');
    if (!toggles.length) return;

    toggles.forEach(function (toggle) {
      var key = toggle.getAttribute('data-toggle');
      var panel = root.querySelector('[data-panel="' + key + '"]');
      if (!panel) return;

      toggle.addEventListener('click', function () {
        var isOpen = !panel.hidden;
        panel.hidden = isOpen;
        toggle.classList.toggle('is-open', !isOpen);
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  document.querySelectorAll('[data-a2k-buybox-tabs]').forEach(initTabs);
})();
